import { FormControl, FormGroup, FormControlLabel, Checkbox, FormLabel, Typography, FormHelperText } from '@mui/material';
import { cloneDeep } from 'lodash';

const MultiCheckbox = ({
    name,
    value = [],
    options,
    onChange,
    label,
    labelProps = {},
    checkboxLabelProps = {},
    formGroupProps = {},
    error
}) => {

    const handleCheckboxChange = (event) => {
        const newSelectedValue = event.target.name;

        let prevSelectedValues = [...value]

        let arr = []
        if (prevSelectedValues?.includes(newSelectedValue)) {
            arr = prevSelectedValues?.filter((selectedValue) => selectedValue !== newSelectedValue);
        } else {
            arr = [...prevSelectedValues, newSelectedValue];
        }

        onChange({ target: { name, value: arr } });
    }

    return (
        <FormControl>
            <FormLabel {...labelProps}>{label}</FormLabel>
            <FormGroup {...formGroupProps}>
                {options.map((option) => (
                    <FormControlLabel
                        key={option?.id ?? option}
                        control={
                            <Checkbox
                                checked={value?.includes(option?.id ?? option)}
                                onChange={handleCheckboxChange}
                                name={option?.id ?? option}
                            />
                        }
                        label={
                            <Typography {...checkboxLabelProps}>{option?.label ?? option}</Typography>
                        }
                    />
                ))}
            </FormGroup>
            <FormHelperText error={!!error}>{error ?? ''}</FormHelperText>
        </FormControl>
    );
};

export default MultiCheckbox;